import useHasPermission from "./useHasPermission";
const LIMITED_PERMISSIONS = {
    CAN_SEE_GENDER: "CAN_SEE_LIMITED_PROFILE_GENDER",
    CAN_SEE_BIRTHDATE: "CAN_SEE_LIMITED_PROFILE_BIRTHDATE",
    CAN_SEE_CUMULATIVE_GPA: "CAN_SEE_LIMITED_PROFILE_CUM_GPA",
    CAN_SEE_TAGS: "CAN_SEE_LIMITED_PROFILE_TAGS",
    CAN_SEE_HIGH_SCHOOL: "CAN_SEE_LIMITED_PROFILE_HIGH_SCHOOL",
    CAN_SEE_INTENT: "CAN_SEE_LIMITED_PROFILE_INTENT",
    CAN_SEE_RACE_ETHNICITY: "CAN_SEE_LIMITED_PROFILE_RACE_ETHNICITY",
};
const useHasLimitedPermission = (student, permission, onCase) => {
    // check caseload
    const canSeeFullProfileForAllStudents = useHasPermission("CAN_SEE_FULL_PROFILE_FOR_ALL_STUDENTS");
    const canSeeFullProfileForMyCaseload = useHasPermission("CAN_SEE_FULL_PROFILE_FOR_MY_CASELOAD");
    // The full profile can be seen if we can see the full profile for all students,
    // or if the visible user is on our caseload and we have permission to see the full profile for students on our caseload
    const fullProfileView = !onCase
        ? canSeeFullProfileForAllStudents
        : canSeeFullProfileForAllStudents || canSeeFullProfileForMyCaseload;
    // if we have full profile view, check full profile permission passed in,
    // otherwise check limited profile permission from map
    const hasFullPermission = useHasPermission(permission);
    const hasLimitedPermission = useHasPermission(
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly CAN_SEE_GENDER: "CAN_SEE_LIMITED_PROFILE_GENDER"; readonly CAN_SEE_BIRTHDATE: "CAN_SEE_LIMITED_PROFILE_BIRTHDATE"; readonly CAN_SEE_CUMULATIVE_GPA: "CAN_SEE_LIMITED_PROFILE_CUM_GPA"; readonly CAN_SEE_TAGS: "CAN_SEE_LIMITED_PROFILE_TAGS"; readonly CAN_SEE_HIGH_SCHOOL: "CAN_SEE_LIMITED_PROFILE_HIGH_SCHOOL";...'.
    LIMITED_PERMISSIONS[permission]);
    return fullProfileView ? hasFullPermission : hasLimitedPermission;
};
export default useHasLimitedPermission;
